var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBghomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 481,
    viewBox: "0 0 192 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 96.1432V0.571777L96 0.571777V96.1432H192Z",
    fill: "#468E87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 480.571V385H0V480.571H96Z",
    fill: "#16332F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192 287.286V191.714H96V287.286H192Z",
    fill: "#EA6C58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192 382.571V287H96V382.571H192Z",
    fill: "#FEF9EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBghomer);
export default __webpack_public_path__ + "static/media/bghomer.a45230e979544cd19471a3a506d21aed.svg";
export { ForwardRef as ReactComponent };